const getIconUrl = icon => {
  var images = require.context('../assets/images/', false, /.png$/)
  return images('./' + icon + '.png')
}

export default getIconUrl
